import React from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { CampaignConfigType } from '../../types';

/**
 * Selectable value in the builder. 'poll' is a builder-only pseudo-type: it is
 * stored as a 'message' config with an isPoll flag (see ConfigurationHeader).
 */
export type BuilderTypeValue = CampaignConfigType | 'poll';

interface TypeFieldProps {
  value: string;
  onChange: (value: BuilderTypeValue) => void;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Campaign type selector. Unlike the original CampaignConfigBuilder TypeField,
 * this lists every supported type, including `text_to_win`, `away_message` and
 * the builder-only `poll`.
 */
export const TYPE_OPTIONS: { value: BuilderTypeValue; label: string }[] = [
  { value: 'message', label: 'Message' },
  { value: 'join', label: 'Join' },
  { value: 'enrollment', label: 'Enrollment' },
  { value: 'reminder', label: 'Reminder' },
  { value: 'annual', label: 'Annual' },
  { value: 'recurring', label: 'Recurring' },
  { value: 'text_to_win', label: 'Text To Win' },
  { value: 'away_message', label: 'Away Message' },
  { value: 'poll', label: 'Poll' },
];

export const TypeField: React.FC<TypeFieldProps> = ({ value, onChange, onClick, disabled = false }) => {
  return (
    <Box onClick={disabled ? undefined : onClick}>
      <FormControl fullWidth>
        <InputLabel>Campaign Type</InputLabel>
        <Select
          labelId="type-select-label"
          id="type-select"
          label="Campaign Type"
          value={value}
          onChange={e => onChange(e.target.value as BuilderTypeValue)}
          onClick={e => e.stopPropagation()}
          disabled={disabled}
        >
          {TYPE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
